import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted }}\n<Visitor::SignedOut />",{ moduleName: "invite-sign/templates/signed-out.hbs" })